import { FourKResolution } from "../components/types";

export const is4kScreen = () => {
  return (
    window.innerWidth >= FourKResolution.x ||
    window.innerWidth >= FourKResolution.y
  );
};
